/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import isObject from './isObject';
import isNotObject from './isNotObject';
import removeEmpty from './removeEmpty';
import getValueByKey from './getValueByKey';
import toOneLevelDepth from './toOneLevelDepth';
import fromOneLevelDepth from './fromOneLevelDepth';

export default {
  isObject,
  isNotObject,
  removeEmpty,
  getValueByKey,
  toOneLevelDepth,
  fromOneLevelDepth,
};
